export default "__VITE_ASSET__ce347848__"